import { env } from 'env';

import { checkIsLocalhost } from '../../helpers/path';
import { customAppThemes } from '../../constants/eventStyles';
import WorldsService from '../../services/WorldsService';

const { REACT_APP_APP_THEME_HOST_NAME } = env;

export const getAppTheme = async () => {
  const isLocalhost = checkIsLocalhost();
  const hostname = isLocalhost
    ? (REACT_APP_APP_THEME_HOST_NAME as string)
    : window.location.hostname;

  if (!REACT_APP_APP_THEME_HOST_NAME && isLocalhost) {
    return customAppThemes.default();
  }

  const eventConfig = await WorldsService.getCustomStyles(hostname);

  if (eventConfig?.customStyles) {
    const colorTheme: string = eventConfig.customStyles?.colorTheme ?? 'light';
    //@ts-ignore
    return customAppThemes[colorTheme.toLowerCase()](eventConfig.customStyles);
  }

  return customAppThemes.default();
};

export const getAppSettings = async () => {
  const hostname = window.location.hostname;

  const worldConfig = await WorldsService.getWorldSettings(hostname);

  return worldConfig.settings || null;
};
